import React from 'react';
import PropTypes from 'prop-types';
import { Sidebar, SidebarItem } from 'gwx-voyager-components';
import './sidebar.scss';


const renderItem = (href, display, icon, activePath, reactRouter, count,subItems,open) => (
	<SidebarItem
		href={href}
		display={display}
		icon={icon}
		active={href && activePath && activePath.startsWith(href)}
		reactRouter={reactRouter}
		count={count}
		subItems={subItems}
		open ={open}
	/>
);

/**
 * An application Sidebar that provides defaulted side-navigation views.
 *
 * This component manages state of the activeHref to highlight the
 * selected item. The parent has the ability to pass in
 * the activeHref based on a hash or url change.
 */
const ApplicationSidebar = ({
	context, activePath, reactRouter, opportunityCount, invitationEnabled
}) => (
	<Sidebar reactRouter={reactRouter}>
		{renderItem(`/${context}/reports`, 'Analyze', 'area-chart', activePath, reactRouter)}
		{renderItem(`/${context}/opportunities`, 'Build', 'user-plus', activePath, reactRouter, opportunityCount)}
		{renderItem(`/${context}/subscriptions`, 'Manage', 'id-card', activePath, reactRouter)}
		{renderItem(`/${context}/reporting/adts`, 'ADT Events', 'table', activePath, reactRouter)}
		{renderItem(`/${context}/reporting/notifications`, 'Notifications', 'table', activePath, reactRouter)}
		{invitationEnabled ? renderItem(`/${context}/clientInvitations`, 'Invitations', 'envelope', activePath, reactRouter) : null}
		{renderItem(`/${context}/administration`, 'Settings', 'cog', activePath, reactRouter)}
	</Sidebar>
);
ApplicationSidebar.defaultProps = {
	activePath: 'reports',
	reactRouter: true,
	opportunityCount: null,
	subItems: null
};
ApplicationSidebar.propTypes = {
	activePath: PropTypes.string,
	context: PropTypes.string.isRequired,
	reactRouter: PropTypes.bool,
	opportunityCount: PropTypes.number
};

export { ApplicationSidebar as default };
